import { FacetConfig } from '../models/facet-config.model';

export const FACET_CONFIGS: FacetConfig[] = [
  {
    key: 'targetAudience',
    translationKey: 'targetAudience',
    showSearch: true,
    chip: { cssClass: 'chip-targetAudience', icon: 'diversity_3', showLabel: true }
  },
  {
    key: 'typeId',
    translationKey: 'type',
    showSearch: false,
    chip: { cssClass: 'chip-typeId', icon: 'label', showLabel: true }
  },
  {
    key: 'availabilityTypeId',
    translationKey: 'availabilityType',
    showSearch: false,
    chip: { cssClass: 'chip-availabilityTypeId', icon: 'schedule', showLabel: true }
  },
  {
    key: 'countyId',
    translationKey: 'county',
    showSearch: true,
    chip: { cssClass: 'chip-countyId', icon: 'map', showLabel: true }
  },
  {
    key: 'cityId',
    translationKey: 'city',
    showSearch: true,
    chip: { cssClass: 'chip-cityId', icon: 'location_city', showLabel: true }
  },
/*  {
    key: 'annexes',
    translationKey: 'annexes',
    showSearch: true,
    chip: { background: '#fef3c7', color: '#92400e', icon: 'attach_file', showLabel: true }
  },
*/  {
    key: 'domainId',
    translationKey: 'domains',
    showSearch: true,
    chip: { cssClass: 'chip-domainId', icon: 'domain', showLabel: true }
  },
  {
    key: 'categoryId',
    translationKey: 'categories',
    showSearch: true,
    chip: { cssClass: 'chip-categoryId', icon: 'category', showLabel: true } 
  },
  {
    key: 'areas',
    translationKey: 'areas',
    showSearch: true,
    chip: { cssClass: 'chip-areas', icon: 'public', showLabel: true }
  }
];
